module.exports = __webpack_public_path__ + "img/1.5bfbdf6c.png";